<template>
    <div class='container'>
        <div class="review">
            <div class="instructions">
                <div class="title">{{ consumer_Rights.name }}</div>
                <div class="line"></div>
                <div class="instructionses" v-html="consumer_Rights.content"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    components: {},
    data() {
        return {
        };
    },
    computed: {
        ...mapState('header', ['consumer_Rights']),
    },
    watch: {},
    methods: {
    },
    created() {
    },
    mounted() {
    },
}
</script>
<style src="./index.scss" lang='scss' scoped></style>
<style src="../Page/index.scss" lang="scss" scoped></style>